import { render, staticRenderFns } from "./RichText2.vue?vue&type=template&id=1507c464&lang=pug"
import script from "./RichText2.vue?vue&type=script&lang=js"
export * from "./RichText2.vue?vue&type=script&lang=js"
import style0 from "./RichText2.vue?vue&type=style&index=0&id=1507c464&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports